<template>
  <router-view />
</template>
<script>
  export default {
    name: 'SetorModule',
  }
</script>
